import { formatPercent } from './percent';

/**
 * Basis points as a percentage with fixed places and a true minus below
 * zero; `signed` adds the plus above zero. "—" when unmeasured.
 */
export function formatBasisPoints(
  value: number | null | undefined,
  {
    signed = false,
    fractionDigits = 2
  }: { signed?: boolean; fractionDigits?: number } = {}
): string {
  return formatPercent(value, {
    from: 'bps',
    digits: fractionDigits,
    sign: signed ? 'signed' : 'minus'
  });
}
